export default __webpack_public_path__ + "static/media/send.a8f01389.svg";